'use strict';
const angular = require('angular');

export class MainTOCSelectionComponent {
  menu = [{
    title: 'Home',
    url: 'main'
  }];

  isCollapsed = true;

  constructor($state, $scope, $rootScope, fetch, lookup) {
    'ngInject';

    this.$state = $state;
    this.$scope = $scope;
    this.fetch = fetch;

    /**
     * Get list of jurisdictions
     */
    $scope.getJurisdictionList = function() {
      fetch.getAllItems('api/data/jurisdictions/list')
        .then(response => {
          
          $scope.jurisdictions = response.data;
          $scope.jurisdiction = response.data[0].jurisdiction;
          // $scope.getStationAreaList($scope.jurisdiction);
        })
        .catch(err => {
          console.log(err);
        })
    }

    //     /**
    //  * Update station area dropdown based on jurisdiction selected
    //  * @param {*} jurisdiction 
    //  */
    //     $scope.getStationAreaList = function (jurisdiction) {
    //       console.log('getting station area list')
    //       lookup.setJurisdiction(jurisdiction);
    //       fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
    //         .then(response => {
    //           
    //           $scope.stationAreas = response.data;
    //           if (lookup.getCurrentStation()) {
    //             $scope.currentSelectedStation = lookup.getCurrentStation();
    //             $scope.getCurrentStationPolicy($scope.type);
    //           } else {
    //             $scope.currentSelectedStation = $scope.stationAreas[0].corridor_id;
    //             $scope.getCurrentStationPolicy($scope.type);
    //           }
    //         console.log($scope.currentSelectedStation, " current selected station");
    //         })
    //         .catch(err => {
    //           console.log(err);
    //         })
    //     }

  }

  $onInit(){
    // this.getJurisdictionList();
    // this.getStationAreaList();
  }

  // getJurisdictionList(){
  //   this.fetch.getAllItems('api/data/jurisdictions/list')
  //   .then(response => {
  //     
  //     this.$scope.jurisdictions = response.data;
  //     this.$scope.jurisdiction = response.data[0].jurisdiction;
  //     this.getStationAreaList(this.$scope.jurisdiction);
  //   })
  //   .catch(err => {
  //     console.log(err);
  //   })
  // }

  // getStationAreaList(jurisdiction){
  //   console.log(`api/data/stationareas/${jurisdiction}`);
  //   this.fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
  //   .then(response => {
  //     
  //     this.$scope.stationAreas = response.data;
  //   })
  //   .catch(err => {
  //     console.log(err);
  //   })
  // }
}


export default angular.module('appApp.maintocselection', [])
  .directive('maintocselection', function() {
    return {
      template: require('./maintocselection.html'),
      restrict: 'EA',
      controller: MainTOCSelectionComponent,
      controllerAs:'mainTOCCtrl',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/maintocselection/maintocselection.directive.js